import { render, staticRenderFns } from "./QEmojiPicker.vue?vue&type=template&id=6885e6f4&scoped=true&"
import script from "./QEmojiPicker.vue?vue&type=script&lang=js&"
export * from "./QEmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./QEmojiPicker.vue?vue&type=style&index=0&id=6885e6f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885e6f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VMenu,VTextField})
